import { Field, Image, ImageField, Link, LinkField, Text } from '@sitecore-jss/sitecore-jss-nextjs';

import IsSitecoreEditing from 'src/utils/isSitecoreEditing';

import { EditorHelp } from 'src/components/layout/_EditorHelp/_EditorHelp';

import styles from '../../callToActions/GroupCallToAction/GroupCallToAction.module.css';

type swiperSlideComponentProps = {
	media: ImageField;
	title: Field<string>;
	description: Field<string>;
	link: LinkField;
	logo?: ImageField;
	buttonColor?: string;
};

export function SwiperSlideComponent(props: swiperSlideComponentProps): JSX.Element {
	const isEditing = IsSitecoreEditing();

	const swiperSlideContent = (title: Field<string>, description: Field<string>, link: LinkField, buttonColor?: string) => {
		return (
			<>
				<Text tag="h3" field={title} className={styles.title} />

				<Text tag="p" field={description} className={styles.body} />

				{(link.value?.href || isEditing) && <Link field={link} className={`${styles.slideButton} button ${buttonColor}`} />}
			</>
		);
	};

	return (
		<>
			<EditorHelp text="Image height 65px" />
			<Image media={props.media} className={styles.icon} loading="lazy" height={80} width={80} />
			{!props.logo ? (
				swiperSlideContent(props.title, props.description, props.link, props.buttonColor)
			) : (
				<div className={styles.body}>
					{swiperSlideContent(props.title, props.description, props.link, props.buttonColor)}
					{(props.logo || isEditing) && <Image media={props.logo} className={styles.icon} />}
				</div>
			)}
		</>
	);
}
